/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Help_DescriptionInputs */

const en_seo_help_description = /** @type {(inputs: Seo_Help_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Answers on booking sessions, training, diet and your account in Complete Athlete.`)
};

const pl_seo_help_description = /** @type {(inputs: Seo_Help_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odpowiedzi o rezerwacjach, treningu, diecie i koncie w Complete Athlete.`)
};

/**
* | output |
* | --- |
* | "Answers on booking sessions, training, diet and your account in Complete Athlete." |
*
* @param {Seo_Help_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const seo_help_description = /** @type {((inputs?: Seo_Help_DescriptionInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Help_DescriptionInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_seo_help_description(inputs)
	return en_seo_help_description(inputs)
});